import React from "react";
import {
    SovosButton,
    SovosToolbarActions,
    SovosToolbarColumn,
    SovosToolbarFilter,
    SovosToolbarGroup,
} from "mosaic-react";
import { Visibility, VisibilityOff } from "mosaic-react-icons";
import { useGridApiContext, GridPreferencePanelsValue } from "@mui/x-data-grid";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const MappingGridToolbar = ({ toolbarProps: tp, defaultToolbarProps }) => {
    const { i18n } = useGlobalValue();
    const { hideDoNotImport, onToggleHideDoNotImport, showDoNotImportToggle } = tp || {};
    const { filterArray, isPreferencesPanelOpen, isFilterPanelOpen } = defaultToolbarProps || {};
    const gridRef = useGridApiContext();

    const appliedFiltersCount = (filterArray || []).reduce(
        (count, item) => count + (item?.filters?.length || 0),
        0,
    );

    const toggleColumnPanel = () => {
        if (!isPreferencesPanelOpen) {
            gridRef.current.showPreferences(GridPreferencePanelsValue.columns);
        } else {
            gridRef.current.hidePreferences();
        }
    };

    const toggleFilterPanel = () => {
        if (!isFilterPanelOpen) {
            gridRef.current.showFilterPanel();
        } else {
            gridRef.current.hideFilterPanel();
        }
    };

    return (
        <SovosToolbarGroup sx={{ width: "100%" }}>
            <SovosToolbarActions>
                {showDoNotImportToggle && (
                    <SovosButton
                        variant="outlined"
                        size="small"
                        startIcon={hideDoNotImport ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                        onClick={onToggleHideDoNotImport}
                        sx={{ fontSize: 12, textTransform: "none", height: 32 }}
                    >
                        {hideDoNotImport ? i18n`Show Do Not Import` : i18n`Hide Do Not Import`}
                    </SovosButton>
                )}
                <SovosToolbarColumn onClick={toggleColumnPanel} />
                <SovosToolbarFilter onClick={toggleFilterPanel} appliedFiltersCount={appliedFiltersCount} />
            </SovosToolbarActions>
        </SovosToolbarGroup>
    );
};

export default MappingGridToolbar;
